import { actionType } from "../store";
import {
  LOAD_DASHBOARD,
  LOADING_DAHSBOARD,
  FETCH_DASHBOARD_REQUEST,
  FETCH_DASHBOARD_REQUEST_SUCCESS,
} from "../types/dashboard.types";

export type dashboardStateType = {
  counts: {
    total_facilities: number;
    total_employees: number;
    total_schedules: number;
    total_new_employees: number;
    total_timesheet: number;
    total_subfacilities: number;
  };
  top_employee: null | any[];
  top_workers: null | any[];
  total_shift_count: null | any[];
  monthly_employee_signup: null | any[];
  loading: boolean;
  save: boolean;
};

const initialState: dashboardStateType = {
  counts: {
    total_facilities: 0,
    total_employees: 0,
    total_schedules: 0,
    total_new_employees: 0,
    total_timesheet: 0,
    total_subfacilities: 0,
  },
  top_employee: null,
  top_workers: null,
  total_shift_count: null,
  monthly_employee_signup: null,
  loading: false,
  save: false,
};

export default function dashboardReducer(
  state = initialState,
  action: actionType
) {
  switch (action.type) {
    case LOAD_DASHBOARD:
      return {
        loading: false,
        counts: action.payload.counts,
        total_shift_count: action.payload.total_shift_count,
        monthly_employee_signup: action.payload.monthly_employee_signup,
        top_employee: action.payload.top_employee,
        top_workers: action.payload.top_workers,
        total_timesheet: action.payload.total_timesheet,
        total_subfacilities: action.payload.total_subfacilities,
      };
    case LOADING_DAHSBOARD:
      return { ...state, loading: true };
    case FETCH_DASHBOARD_REQUEST:
      return {
        ...state,
        customfield: null,
        loading: true,
      };

    case FETCH_DASHBOARD_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        customfield: action.payload,
      };
    default:
      return state;
  }
}
